import { render, staticRenderFns } from "./MerchantCourse.vue?vue&type=template&id=a8c1d7be&scoped=true&"
import script from "./MerchantCourse.vue?vue&type=script&lang=js&"
export * from "./MerchantCourse.vue?vue&type=script&lang=js&"
import style0 from "./MerchantCourse.vue?vue&type=style&index=0&id=a8c1d7be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c1d7be",
  null
  
)

export default component.exports